import { object, optional, string } from 'zod';

export const QUIZ_SET_TITLE_MAX_LENGTH = 60;

export const QUIZ_MAP_TEMPLATE_REQUIRED_MESSAGE =
  'Background template is required' as const;

export const SUBJECT_REQUIRED_MESSAGE = 'Subject is required' as const;

export const AT_LEAST_TWO_CHARACTER_REQUIRED_MESSAGE =
  'Title must be at least 2 characters' as const;

export const BuildQuizSetBasicInfoSchema = object({
  id: optional(string()),
  title: string()
    .max(QUIZ_SET_TITLE_MAX_LENGTH, 'Title must be at most 60 characters')
    .refine(
      title => title.length !== 1,
      AT_LEAST_TWO_CHARACTER_REQUIRED_MESSAGE,
    ),
  subject: string().min(1, SUBJECT_REQUIRED_MESSAGE),
  subSubject: optional(string()),
  templateId: string().min(1, QUIZ_MAP_TEMPLATE_REQUIRED_MESSAGE),
  templateType: string(),
});

export const getBuildQuizSetBasicInfoSchema = () => {
  return BuildQuizSetBasicInfoSchema;
};

export type BuildQuizSetBasicInfoSchemaType = Zod.infer<
  typeof BuildQuizSetBasicInfoSchema
>;
